import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from "rxjs/Subscription";
import {filter} from "rxjs/operators";
import {LayoutService} from "../../../shared/services/layout/layout.service";
import {NavigationEnd, Router} from "@angular/router";
import {ContentService} from "../../../shared/services/content/content.service";
import {LanguageService} from "../../../shared/services/language/language.service";

declare const $: any;

@Component({
    selector: 'app-public-wrapper',
    templateUrl: './public-wrapper.component.html',
    styleUrls: ['./public-wrapper.component.scss']
})
export class PublicWrapperComponent implements OnInit, OnDestroy, AfterViewInit {


    @ViewChild('sidebar')
    sidebar: ElementRef;

    private routerSubscripton: Subscription;
    private languageSubscripton: Subscription;

    public currentLanguage = 'en';

    constructor(private router: Router,
                private layoutService: LayoutService,
                private contentService: ContentService,
                private languageService: LanguageService) {
    }

    ngOnInit() {
        this.subscribeRouterEvents();
        this.subscribeLanguageEvents();
    }

    ngAfterViewInit(): void {
        $(this.sidebar.nativeElement).sidebar({
            transition: 'overlay'
        });
    }

    ngOnDestroy(): void {
        this.unsubscribeRouterEvents();
        this.unsubscribeLanguageEvents();
    }

    toggleSidebar = () => {
        $(this.sidebar.nativeElement).sidebar('toggle');
    };

    private subscribeRouterEvents() {
        this.routerSubscripton = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((val) => {
            $(this.sidebar.nativeElement).sidebar('hide');
            window.scrollTo(0, 0);
        });
    }

    private unsubscribeRouterEvents() {
        this.routerSubscripton.unsubscribe();

    }


    private subscribeLanguageEvents() {
        this.languageSubscripton = this.languageService.language.subscribe((val) => {
            this.currentLanguage = val;
        });
    }

    private unsubscribeLanguageEvents() {
        this.languageSubscripton.unsubscribe();
    }

    setLanguage = (key) => {
        this.languageService.setCurrentLanguage(key);
    }

}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/public/public-wrapper/public-wrapper.component.ts